(function($){
  "use strict"; // Start of use strict    

  /* Initialization */

  $(window).load(function(){

    // Page loader
    $(".page-loader div").delay(0).fadeOut();
    $(".page-loader").delay(200).fadeOut("slow");

    $(window).trigger("scroll");
    $(window).trigger("resize");

  });

  $(document).ready(function(){

    $(window).trigger("resize");

    init_classic_menu(); 
    init_mobile_hover();
    init_wishlist();
    init_parallax();  

    init_to_top();
    init_owl_carousel();
    init_fancybox(); 
    init_search(); 
    init_accordion(); 
    init_wow();   



  });

  $(window).resize(function(){

    init_classic_menu_resize();
    js_height_init();

  });



  // Sections   
  var pageSection = $("section, div.image");
  pageSection.each(function(indx){

    if ($(this).attr("data-background")){
      $(this).css("background-image", "url(" + $(this).data("background") + ")");
    }

  });    

  function height_line(height_object, height_donor){
    height_object.height(height_donor.height());
    height_object.css({
      "line-height": height_donor.height() + "px"
    });
  }  


  /* Navigation */    
  function init_classic_menu_resize(){

    // Mobile menu max height
    $(".mobile-on .desktop-nav > ul").css("max-height", $(window).height() - $(".main-nav").height() - 20 + "px");

    // Mobile menu style toggle
    if ($(window).width() <= 1024) {
      $(".main-nav").addClass("mobile-on");
    }
    else 
      if ($(window).width() > 1024) {
        $(".main-nav").removeClass("mobile-on");
        $(".desktop-nav").show();
      }
  }

  function init_classic_menu(){    

    // Navbar sticky

    if ($(window).width() > 767) {
      $(".js-stick").sticky({
        topSpacing: 0
      });     
    }

    height_line($(".inner-nav > ul > li > a"), $(".main-nav"));

  }







  /* Mobile menu hover */
  function init_mobile_hover() {
    (function ($) {

      $( ".drawer-toggle" ).click(function() { 
        $("body").toggleClass("drawer-open"); 
      });


      $( ".drawer-overlay" ).click(function() { 
        $("body").removeClass("drawer-open"); 
      });


      $( ".drawer-nav li.has-mega > a, .drawer-nav li.has-dropdown > a" ).click(function(e) { 
        $(this).parent().find(".mega, .dropdown").slideToggle();  
        $(this).parent().find("i").toggleClass("fa-angle-down fa-angle-up");  

        e.preventDefault();
      });


      if ($(window).width() <= 1024) {

        $( "li.has-mega > a, li.has-dropdown > a" ).click(function(e) { 
          e.preventDefault();
        });

      }

    })(jQuery);
  };



  /* To top */
  function init_to_top(){

    var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = $('.cd-top');

    //hide or show the "back to top" link
    $(window).scroll(function(){
      ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
      if( $(this).scrollTop() > offset_opacity ) { 
        $back_to_top.addClass('cd-fade-out');
      }
    });

    //smooth scroll to top
    $back_to_top.on('click', function(event){
      event.preventDefault();
      $('body,html').animate({
        scrollTop: 0 ,
      }, scroll_top_duration
                            );
    });

  }


})(jQuery); // End of use strict


/* Wish List */
function init_wishlist(){
  $("button.add-wishlist").click(function(e){
    e.preventDefault();
    var d = $(this).parent();
    $.ajax({
      type:"POST",
      url:"/contact",
      data:d.serialize(),
      beforeSend:function(){

      },
      success:function(n){
        d.html('<a class="add-wishlist" href="/pages/wish-list"><i class="fa fa-heart"></i></a>');
        if (!!$.prototype.fancybox)
          $.fancybox.open([{
            type: 'inline',
            autoScale: true,
            minHeight: 30,
            content: '<p class="fancybox-error">' + 'Added to your wishlist.' + '</p>',
            helpers: {
              overlay: {
                locked: false
              }
            }
          }], {
            padding: 0
          });
        else
          alert('added to wishlist');
      },
      error:function(){

      }
    })
  });
}


/* Parallax */    
function init_parallax(){

  $window = $(window);
  $('section[data-type="background"]').each(function(){
    var $bgobj = $(this);
    $(window).scroll(function() {

      var yPos = -($window.scrollTop() / $bgobj.data('speed')); 
      var coords = '50% '+ yPos + 'px';

      $bgobj.css({ backgroundPosition: coords });

    });
  });	

}

/* Owl Carousel */
function init_owl_carousel(){
  (function($){
    "use strict";

    // Fullwidth slider
    $(".fullwidth-slider").owlCarousel({ 
      slideSpeed: 350,
      autoPlay: 5000,
      singleItem: true,
      navigation: true,
      navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"]
    });             

    // Product slider
    var owl = $(".product-slider");
    owl.owlCarousel({
      slideSpeed: 500,
      autoPlay: false,
      pagination: false            
    });
    $(".go-right").click(function(){
      owl.trigger('owl.next');
    })
    $(".go-left").click(function(){
      owl.trigger('owl.prev');
    })  

    /* Product images slider */
    var sync1 = $("#product-images");
    var sync2 = $("#product-thumbs");

    sync1.owlCarousel({
      singleItem: true,
      slideSpeed: 1000,
      autoHeight: true,
      navigation: true,
      navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
      pagination: false,
      afterAction: syncPosition,
      responsiveRefreshRate: 200,
    });

    sync2.owlCarousel({
      items: 6,
      itemsDesktop: [1199,6],
      itemsDesktopSmall: [979,6],
      itemsTablet: [768,5],
      itemsMobile: [479,4],
      pagination: false,
      responsiveRefreshRate: 100,
      afterInit: function(el){
        el.find(".owl-item").eq(0).addClass("synced");
      }
    });

    function syncPosition(el){
      var current = this.currentItem;
      $("#product-thumbs")
      .find(".owl-item")
      .removeClass("synced")
      .eq(current)
      .addClass("synced")
      if($("#product-thumbs").data("owlCarousel") !== undefined){
        center(current)
      }
    }

    $("#product-thumbs").on("click", ".owl-item", function(e){
      e.preventDefault();
      var number = $(this).data("owlItem");
      sync1.trigger("owl.goTo",number);
    });

    function center(number){
      var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
      var num = number;
      var found = false;
      for(var i in sync2visible){
        if(num === sync2visible[i]){
          var found = true;
        }
      }
      if(found===false){
        if(num>sync2visible[sync2visible.length-1]){
          sync2.trigger("owl.goTo", num - sync2visible.length+2)
        }else{
          if(num - 1 === -1){
            num = 0;
          }
          sync2.trigger("owl.goTo", num);
        }
      } else if(num === sync2visible[sync2visible.length-1]){
        sync2.trigger("owl.goTo", sync2visible[1])
      } else if(num === sync2visible[0]){
        sync2.trigger("owl.goTo", num-1)
      }
    }


  })(jQuery);
};

/* Fancybox */
function init_fancybox(){
  (function($){        

    $(".fancybox").fancybox({
      afterShow: function () {
        $(".fancybox-inner").contents().find("input.form-control:first").attr("tabindex",1).focus();
      },
      helpers: {
        overlay: {
          locked: false
        }
      }
    }); 

  })(jQuery);
};  


/* Search toggle */
function init_search(){

  $(".toggle-search").click(function(){

    $(".top-search").slideToggle();

    $( ".top-search .search" ).focus();

    return false;

  });

}; 

/* Accordion */
function init_accordion(){

  var allToggles = $(".accordion > dd").hide();
  allToggles.first().slideDown();

  $(".accordion > dt > a").click(function(){

    if ($(this).hasClass("active")) {

      $(this).parent().next().slideUp();
      $(this).removeClass("active");

    }
    else {
      var current = $(this).parent().next("dd");
      $(this).addClass("active");
      $(this).parent().next().slideDown();
    }

    return false;
  });

};         

/* Heights */
function js_height_init(){
  (function($){
    $(".js-height-full").height($(window).height() - $("header").height());
    $(".js-height-parent").each(function(){
      $(this).height($(this).parent().first().height());
    });
  })(jQuery);

  (function($){
    var maxHeight = $(window).height() - $("header").height();
    $(".dd-cart").css({ "max-height": maxHeight + 'px' });    
  })(jQuery);
}

/* WOW animations */
function init_wow(){
  (function($){    

    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 90,
      mobile: false, 
      live: true 
    });

    if ($("body").hasClass("appear-animate")){
      wow.init(); 
    }        

  })(jQuery);
}


/* Swatch */
function updatePricing() {}

$(document).ready(function(){
  $(".swatch :radio").change(function() {
    var t = $(this).closest(".swatch").attr("data-option-index");
    var n = $(this).val();
    $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
  });
});





